/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './folder-item-page.component.html';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {FolderModel} from './folder-api.service';
import {ADMIN_RESOURCE_PAGES} from '../common/controller/admin-resource-pages';
import {FolderAnalysisPageComponent} from './folder-analysis-page.component';
import {FolderEditPageComponent} from './folder-edit-page.component';

@Component({
  standalone: true,
  imports: [...ADMIN_RESOURCE_PAGES, FolderAnalysisPageComponent, FolderEditPageComponent],
  selector: 'adn-folder-item-page',
  template
})
export class FolderItemPageComponent {
  @Input() state: SignalAdminResourcePageState<FolderModel>;
}
